export default defineNuxtPlugin(() => {
  try {
    const key = 'delightDemoSessionLandingPage'
    if (!sessionStorage.getItem(key)) sessionStorage.setItem(key, window.location.href)
  } catch {
    // Tracking remains usable when browser storage is unavailable.
  }
})
